import React, { useState } from 'react';
import './ShipmentInformation.scss';
import DynaSelectBox from '../../../../A13/DynaView/DynaSelectBox';
import DynaInput from '../../../../A13/DynaView/DynaInput';
import { TrashSVG } from '../../../ChikaExportSvg/ChikaExportSvg';
import UtilsFunctions from '../../../../../utils/UtilsFunctions';
import { toast } from 'react-toastify';

const ShipmentInformation = ({ sendData, setSendData, productOptions = [] }) => {
  const [newProduct, setNewProduct] = useState({
    id_product: '',
    product_name: '',
    gh_masraf: '',
    gh_forosh: '',
    te: ''
  });

  // ====================  بروزرسانی خودکار فیلدهای محصول فقط هنگام انتخاب جدید ====================
  const handleProductChange = (selectedValue) => {
    const product = productOptions.find((p) => p.value === selectedValue);

    if (product) {
      const percentProfit = Number(sendData.percent_profit) || 0;
      const ghMasraf = Number(product.gh_masraf) || 0;
      const ghForosh = Math.round(ghMasraf * (1 - percentProfit / 100));

      setNewProduct((prev) => ({
        ...prev,
        id_product: selectedValue,
        product_name: product.label,
        gh_masraf: ghMasraf,
        gh_forosh: ghForosh,
        te: product.stock_count || 0
      }));
    }
  };

  // ====================  مدیریت تغییرات دستی در فرم افزودن محصول ====================
  const handleChange = (name, value) => {
    if (name === "gh_forosh") {
      if (Number(value) > Number(newProduct.gh_masraf)) {
        return;
      }
    }
    setNewProduct((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  // ==================== افزودن محصول به لیست محصولات ====================
  const handleAddProduct = () => {
    const { id_product, te } = newProduct;

    const validations = {
      'لطفاً یک محصول انتخاب کنید.': !id_product,
      'لطفاً تعداد محصول را مشخص کنید.': !te || Number(te) === 0,
      'این محصول قبلاً اضافه شده است.': sendData.products.some((p) => +p.id_product === +id_product)
    };

    for (const [message, condition] of Object.entries(validations)) {
      if (condition) {
        toast.error(message);
        return;
      }
    }

    setSendData((prev) => ({
      ...prev,
      products: [...prev.products, newProduct]
    }));

    setNewProduct({
      id_product: '',
      product_name: '',
      gh_masraf: '',
      gh_forosh: '',
      te: ''
    });
  };

  // ==================== حذف محصول از لیست ====================
  const handleDeleteProduct = (index) => {
    setSendData((prev) => ({
      ...prev,
      products: prev.products.filter((_, i) => i !== index)
    }));
  };

  // ==================== به‌روزرسانی فیلدهای قابل ویرایش در جدول ====================
  const handleTableChange = (index, field, value) => {
    const numericValue = UtilsFunctions.removeCommas(value).replace(/\D/g, "");

    if (field === "gh_forosh") {
      const ghMasraf = Number(sendData.products[index].gh_masraf) || 0;
      if (Number(numericValue) > ghMasraf) {
        return;
      }
    }

    setSendData((prev) => ({
      ...prev,
      products: prev.products.map((product, i) =>
        i === index ? { ...product, [field]: numericValue } : product
      )
    }));
  };

  // ==================== محاسبه جمع کل محصولات ====================
  const calculateTotal = () => {
    return sendData.products.reduce((sum, product) =>
      sum + Number(product.gh_forosh) * Number(product.te), 0
    );
  };

  return (
    <div className='shipment__information'>
      <div className='form__grid'>
        <DynaSelectBox
          options={productOptions}
          hasFilter={false}
          label='انتخاب محصول'
          className='solid-dyna-input'
          value={newProduct.id_product}
          onChange={(data) => handleProductChange(data.value)}
        />
        <DynaInput
          label='قیمت مصرف کننده'
          name='gh_masraf'
          className='solid-dyna-input'
          placeholder='قیمت مصرف کننده را وارد کنید'
          value={UtilsFunctions.addCommas(newProduct.gh_masraf)}
          type='text'
          setDataFromComponent={(data) => handleChange('gh_masraf', data.gh_masraf)}
          hasComma={true}
          disabled={true}
        />
        <DynaInput
          label='قیمت فروش'
          name='gh_forosh'
          className='solid-dyna-input'
          placeholder='قیمت فروش را وارد کنید'
          value={UtilsFunctions.addCommas(newProduct.gh_forosh)}
          type='text'
          setDataFromComponent={(data) => handleChange('gh_forosh', data.gh_forosh)}
          hasComma={true}
          disabled={!newProduct.id_product}
        />
        <div className='group__flex'>
          <DynaInput
            label='تعداد'
            name='te'
            className='solid-dyna-input'
            placeholder='تعداد را وارد کنید'
            value={UtilsFunctions.addCommas(newProduct.te)}
            type='text'
            setDataFromComponent={(data) => handleChange('te', data.te)}
            hasComma={true}
            disabled={!newProduct.id_product}
          />
          <button className='add__button' onClick={handleAddProduct}>
            افزودن
          </button>
        </div>
      </div>

      <div className='table__section'>
        <div className='table__box'>
          <ul className='table__header'>
            <li className='table__row'>
              <div style={{ width: '30%' }} className='table__cell'>نام محصول</div>
              <div style={{ width: '15%' }} className='table__cell'>قیمت مصرف کننده</div>
              <div style={{ width: '15%' }} className='table__cell'>قیمت فروش</div>
              <div style={{ width: '15%' }} className='table__cell'>تعداد</div>
              <div style={{ width: '15%' }} className='table__cell'>مجموع</div>
              <div style={{ width: '10%' }} className='table__cell'>عملیات</div>
            </li>
          </ul>
          <ul className='table__body'>
            {sendData.products.length > 0 ? (
              sendData.products.map((product, index) => (
                <li key={index} className='table__row'>
                  <div style={{ width: '30%' }} className='table__cell'>{product.product_name}</div>
                  <div style={{ width: '15%' }} className='table__cell'>{UtilsFunctions.addCommas(product.gh_masraf)}</div>
                  <div style={{ width: '15%' }} className='table__cell'>
                    <input
                      type='text'
                      value={UtilsFunctions.addCommas(product.gh_forosh)}
                      onChange={(e) => handleTableChange(index, 'gh_forosh', e.target.value)}
                      onFocus={() => product.gh_forosh == 0 && handleTableChange(index, "gh_forosh", "")}
                      onBlur={() => product.gh_forosh == "" && handleTableChange(index, "gh_forosh", "0")}
                    />
                  </div>
                  <div style={{ width: '15%' }} className='table__cell'>
                    <input
                      type='text'
                      value={UtilsFunctions.addCommas(product.te)}
                      onChange={(e) => handleTableChange(index, 'te', e.target.value)}
                      onFocus={() => product.te == 0 && handleTableChange(index, "te", "")}
                      onBlur={() => product.te == "" && handleTableChange(index, "te", "0")}
                    />
                  </div>
                  <div style={{ width: '15%' }} className='table__cell'>
                    {UtilsFunctions.addCommas(product.gh_forosh * product.te)}
                  </div>
                  <div style={{ width: '10%' }} className='table__cell operation'>
                    <button className='trash__button' onClick={() => handleDeleteProduct(index)}>
                      <TrashSVG />
                    </button>
                  </div>
                </li>
              ))
            ) : (
              <p className='table__empty'>اطلاعاتی موجود نیست</p>
            )}
          </ul>
        </div>
      </div>

      {sendData.products.length > 0 && (
        <div className='payment__price'>
          <div className='payment__total'>
            <span>جمع کل</span>
            <span>{UtilsFunctions.addCommas(calculateTotal())}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ShipmentInformation;